import "./index.css"
import React from "react"
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { QueryClient } from "@tanstack/react-query";
import { PersistQueryClientProvider } from '@tanstack/react-query-persist-client'
import { get, set, del } from 'idb-keyval';
import App from "./App";
import { ProfilesContextProvider } from "./lib/profiles";

// set light mode
document.documentElement.classList.add('dark');
document.documentElement.classList.toggle('dark', false);
localStorage.setItem('darkMode', false);

function createIDBPersister(idbValidKey = "reactQueryPersistentCache") {
  return {
    persistClient: async function(client) {
      await set(idbValidKey, client);
    },
    restoreClient: async function() {
      return await get(idbValidKey);
    },
    removeClient: async function() {
      await del(idbValidKey);
    }
  };
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false
    }
  }
});

const root = createRoot(document.getElementById("root"));
root.render(<React.StrictMode>
    <BrowserRouter>
      <PersistQueryClientProvider client={queryClient} persistOptions={{ persister: createIDBPersister() }}>
        <ProfilesContextProvider>
          <App />
        </ProfilesContextProvider>
      </PersistQueryClientProvider>
    </BrowserRouter>
</React.StrictMode>);
